import { resolveIcon } from '../../../styles/icons'
import styled from 'styled-components'
import useTranslation from '../../../hooks/useTranslation'

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.82rem;
    color: ${({ theme }) => theme.font.label};
`

const Chip = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    background: none;
    border: 1px solid ${({ theme }) => theme.form.border};
    border-radius: 999px;
    padding: 0.1rem 0.6rem;
    font-size: 0.75rem;
    color: ${({ theme }) => theme.font.color};
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        border-color: ${({ theme }) => theme.form.activeBorder};
    }
`

const InventoryIndicator = ({ itemId, totalQty, locationCount, label, buttonLabel, icon, onOpenModal }) => {
    const { t } = useTranslation()

    if (!itemId) return null

    return (
        <Row>
            <span>{t(label)}: <strong>{totalQty}</strong></span>
            {locationCount > 0 && (
                <Chip onClick={onOpenModal}>
                    {resolveIcon(icon)} {locationCount} {t(buttonLabel)} ▸
                </Chip>
            )}
        </Row>
    )
}

export default InventoryIndicator
